import { render, staticRenderFns } from "./colorHighlightedPhrase.vue?vue&type=template&id=482bf584&scoped=true"
import script from "./colorHighlightedPhrase.vue?vue&type=script&lang=js"
export * from "./colorHighlightedPhrase.vue?vue&type=script&lang=js"
import style0 from "./colorHighlightedPhrase.vue?vue&type=style&index=0&id=482bf584&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482bf584",
  null
  
)

export default component.exports